import { render, staticRenderFns } from "./popup-actions.vue?vue&type=template&id=6548c4d8"
import script from "./popup-actions.vue?vue&type=script&lang=js"
export * from "./popup-actions.vue?vue&type=script&lang=js"
import style0 from "./popup-actions.vue?vue&type=style&index=0&id=6548c4d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports